import Input from 'components/Input/Input';
import TokenInput from 'components/Input/TokenInput';
import InstructionBox from 'components/Instruction/InstructionBox';
import { InstructionCallout } from 'components/Instruction/InstructionCallout';
import InstructionItem from 'components/Instruction/InstructionItem';
import { AppLink } from 'components/Link/AppLink';
import COLORS from 'constants/colors';
import { useAutoScrollInstructions } from 'hooks/useAutoScrollInstructions';
import styled from 'styled-components';
import MainContainer from '../../SignInMainContainer';

interface WebserviceProps {
  apiToken: {
    value: string;
    invalid: boolean;
    onChange: (value: string, invalid?: boolean) => void;
  };
  tenantId: {
    value: string;
    invalid: boolean;
    onChange: (value: string, invalid?: boolean) => void;
  };
  fullDomain: {
    value: string;
    invalid: boolean;
    onChange: (value: string, invalid?: boolean) => void;
  };
  sandboxMode: boolean;
  instructionsLink?: string;
  instructionsInnerHtmlToScroll?: string;
}

const StyledInstructionBox = styled(InstructionBox)`
  margin-bottom: 12px;
`;

const Webservice = ({
  apiToken,
  tenantId,
  fullDomain,
  sandboxMode,
  instructionsLink,
  instructionsInnerHtmlToScroll,
}: WebserviceProps) => {
  useAutoScrollInstructions(instructionsLink, instructionsInnerHtmlToScroll);

  return (
    <>
      {instructionsLink && (
        <InstructionCallout
          link={instructionsLink}
          innerHtmlToScroll={instructionsInnerHtmlToScroll}
        >
          Open{' '}
          <AppLink
            href={instructionsLink}
            rel="noreferrer"
            target="_blank"
            showInFrame
            innerHtmlToScroll={instructionsInnerHtmlToScroll}
          >
            this guide
          </AppLink>{' '}
          to find the required values. Then paste them below and click Connect.
        </InstructionCallout>
      )}
      <StyledInstructionBox>
        <InstructionItem index={1} badgeColor={COLORS.GRAY.GRAY_600}>
          Navigate to Web Services
        </InstructionItem>
        <InstructionItem index={2} badgeColor={COLORS.GRAY.GRAY_600}>
          Find and paste the required information below
        </InstructionItem>
      </StyledInstructionBox>
      <MainContainer useNewDesign>
        <TokenInput
          value={tenantId.value}
          onChange={(event) =>
            tenantId.onChange(event.target.value, !event.target.validity.valid)
          }
          invalid={tenantId.invalid}
          label="User API Key"
          id="tenantId"
          {...(!sandboxMode && {
            characterLimit: 12,
            minLength: 12,
            maxLength: 12,
          })}
        />
        <TokenInput
          value={apiToken.value}
          onChange={(event) =>
            apiToken.onChange(event.target.value, !event.target.validity.valid)
          }
          invalid={apiToken.invalid}
          label="Customer API Key"
          id="apiToken"
          {...(!sandboxMode && {
            characterLimit: 5,
            minLength: 5,
            maxLength: 5,
          })}
        />
        <Input
          value={fullDomain.value}
          onChange={(event) => fullDomain.onChange(event.target.value)}
          invalid={fullDomain.invalid}
          label="Web Service URL"
          id="fullDomain"
          helperText="Example: https://service.ultipro.com"
        />
      </MainContainer>
    </>
  );
};

export default Webservice;
